import React from 'react';
import toast, { Toaster } from 'react-hot-toast';

import {confirmAlert} from "react-confirm-alert";
import Role from "../../inc/Role";
import {NavLink, useNavigate} from "react-router-dom";
import * as Icon from "react-bootstrap-icons";
import {Config} from '../../Config'
import * as Utils from "../../inc/Utils";
import moment from "moment-timezone";

export default function AdsNamingCreate() {
    const roles = new Role();
    let userId = roles.loginUserId;

    let btnTextDefault = 'บันทึกข้อมูล';
    let btnTextLoading = 'กำลังบันทึก..';
    let [isLoading, setLoading] = React.useState(false); 
    let [inputType, setSelectType] = React.useState(null);
    const navigate = useNavigate();

    let refName = React.useRef();  

    const onCreate = () => {
        let name = refName.current.value; 
        if(!name) {
            toast.error("กรุณาระบุ ชื่อ Ads Naming");
            refName.current.focus();
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการบันทึกข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: () => {
                            setLoading(true);

                            let statusChecked = document.getElementsByName('statusChecked');

                            let items = [];
                            let checkboxes = document.getElementsByName('typeIds[]');
                            for (let i = 0; i < checkboxes.length; i++) {
                                if(checkboxes[i].checked) {
                                    items.push({'typeId': checkboxes[i].value});
                                }
                            }

                            const body = {
                                name: name,
                                status: statusChecked[0].checked ? 1:0,
                                inputType: inputType ?? null,
                                createdBy: userId,
                                createdAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                items: items
                            };
                            fetch(Config.url.API_URL +'/api/adsNaming/create', {
                                method: 'POST',
                                body: JSON.stringify(body),
                                headers: {
                                    'Content-Type':'application/json',
                                    'x-access-token': roles.accessToken
                                }
                            }).then(response => {
                                setLoading(false);
                                if(response.ok) {
                                    return response.json();
                                }
                                else {
                                    return response.json().then(err => Promise.reject(err));
                                }
                            }).then(result => {
                                if(result) {
                                    toast.success("บันทึกข้อมูลเรียบร้อย");
                                    setTimeout(function () {
                                        navigate('/adsNaming', {replace: true});
                                    }, 1500);
                                }
                            }).catch(err => {
                                toast.error(err.message);
                            })
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    const onChangeInputType = (Id) => setSelectType(Id);

    return (
        <main>
            <div className="row table-toolbar mb-2">
                <div className="col-6 align-self-center">
                    <div className="h6 d-inline"><span className="text-success">&#8226;</span> Master Ads Naming Format</div>
                    <span className="ms-1">/</span> <span className="text-muted">Create</span>
                </div>
                <div className="col-6 text-end align-self-center toolbars">
                </div>
            </div>
            <div className="rounded bg-white p-4 shadow">
                <div className="row">
                    <div className="col-12 col-md-6">
                        <form className="row g-3">
                            <div className="col-12">
                                <label htmlFor="name" className="form-label">ชื่อ Ads Naming <span className="text-danger">*</span></label>
                                <input type="text" className="form-control" id="name" ref={refName} maxLength={100} />
                            </div>
                            <div className="col-12">
                                <label htmlFor="typeCampaignx" className="form-label">ประเภท</label>
                                <div className="form-check ms-2">
                                    <input className="form-check-input" name="typeIds[]" type="checkbox" value={Utils.ADSNAMING_TYPE_CAMPAIGN} id="typeCampaign" />
                                    <label className="form-check-label" htmlFor="typeCampaign">Campaign</label>
                                </div>
                                <div className="form-check ms-2 mt-2">
                                    <input className="form-check-input" name="typeIds[]" type="checkbox" value={Utils.ADSNAMING_TYPE_SETNAME} id="typeSetName" />
                                    <label className="form-check-label" htmlFor="typeSetName">Set Name</label>
                                </div>
                            </div>
                            <div className="col-12">
                                <label htmlFor="inputTypex" className="form-label">Input Type</label>
                                <select className="form-select" id="inputType" onChange={(event) => onChangeInputType(event.target.value)} value={inputType ?? ''}>
                                    <option value="">Default/Dropdown</option>
                                    <option value={Utils.ADSNAMING_TYPE_SLUG_PROJECT}>Slug Project</option>
                                    <option value={Utils.ADSNAMING_TYPE_SLUG_PROMOTION}>Slug Promotion</option>
                                    <option value={Utils.ADSNAMING_TYPE_SLUG_SPECIAL}>Slug Special</option>
                                    <option value={Utils.ADSNAMING_TYPE_KOL_PAGE}>Kol Page</option>
                                    <option value={Utils.ADSNAMING_TYPE_FREEFORM}>Free Form</option>
                                </select>
                            </div>
                            <div className="col-12">
                                <label htmlFor="statusx" className="form-label">สถานะ</label>
                                <div className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" name="statusChecked" id="status" defaultChecked={true} />
                                    <label className="form-check-label" htmlFor="status"></label>
                                </div>
                            </div>
                            <div className="col-12">
                                <button type="button" className="btn btn-primary" onClick={onCreate}><span
                                    className={isLoading ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span> {isLoading ? btnTextLoading : btnTextDefault}</button>
                                <NavLink className="btn btn-sm btn-light ms-2" to='/adsNaming'><span><Icon.ArrowLeft/> กลับไป</span></NavLink>
                                <Toaster position="bottom-right" />
                            </div>
                        </form>
                    </div>
                    <div className="col-12 col-md-6"></div>
                </div>
            </div>
        </main>
    );
} 